
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PurchaseOrderResource,
  PurchaseOrderUpsertRequest,
} from '../models';
import {
    PurchaseOrderResourceFromJSON,
    PurchaseOrderResourceToJSON,
    PurchaseOrderUpsertRequestFromJSON,
    PurchaseOrderUpsertRequestToJSON,
} from '../models';

export interface GetPurchaseOrderByNumberByAdminRequest {
    companyId: string;
    purchaseOrderNumber: string;
}

export interface UpsertProjectPurchaseOrderByAdminRequest {
    projectId: string;
    purchaseOrderUpsertRequest: PurchaseOrderUpsertRequest;
}

export interface UpsertQuotePurchaseOrderByAdminRequest {
    quoteId: string;
    purchaseOrderUpsertRequest: PurchaseOrderUpsertRequest;
}

/**
 * 
 */
export class PurchaseOrderAdminApi extends runtime.BaseAPI {

    /**
          */
    async getPurchaseOrderByNumberByAdminRaw(requestParameters: GetPurchaseOrderByNumberByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PurchaseOrderResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getPurchaseOrderByNumberByAdmin().'
            );
        }

        if (requestParameters['purchaseOrderNumber'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderNumber',
                'Required parameter "purchaseOrderNumber" was null or undefined when calling getPurchaseOrderByNumberByAdmin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['purchaseOrderNumber'] != null) {
            queryParameters['purchaseOrderNumber'] = requestParameters['purchaseOrderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PurchaseOrderResource>({
            path: `/project-client/api/admin/purchase-order/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PurchaseOrderResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPurchaseOrderByNumberByAdmin(requestParameters: GetPurchaseOrderByNumberByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PurchaseOrderResource> {
        const response = await this.getPurchaseOrderByNumberByAdminRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async reindexPurchaseOrdersRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/admin/purchase-orders/reindex`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async reindexPurchaseOrders(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexPurchaseOrdersRaw(initOverrides);
    }

    /**
          */
    async upsertProjectPurchaseOrderByAdminRaw(requestParameters: UpsertProjectPurchaseOrderByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling upsertProjectPurchaseOrderByAdmin().'
            );
        }

        if (requestParameters['purchaseOrderUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderUpsertRequest',
                'Required parameter "purchaseOrderUpsertRequest" was null or undefined when calling upsertProjectPurchaseOrderByAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/admin/purchase-order/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderUpsertRequestToJSON(requestParameters['purchaseOrderUpsertRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async upsertProjectPurchaseOrderByAdmin(requestParameters: UpsertProjectPurchaseOrderByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertProjectPurchaseOrderByAdminRaw(requestParameters, initOverrides);
    }

    /**
          */
    async upsertQuotePurchaseOrderByAdminRaw(requestParameters: UpsertQuotePurchaseOrderByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling upsertQuotePurchaseOrderByAdmin().'
            );
        }

        if (requestParameters['purchaseOrderUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderUpsertRequest',
                'Required parameter "purchaseOrderUpsertRequest" was null or undefined when calling upsertQuotePurchaseOrderByAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/admin/purchase-order/quote/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderUpsertRequestToJSON(requestParameters['purchaseOrderUpsertRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async upsertQuotePurchaseOrderByAdmin(requestParameters: UpsertQuotePurchaseOrderByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertQuotePurchaseOrderByAdminRaw(requestParameters, initOverrides);
    }

}
